/**
 * TODO:
 * Remove this <AdFrame> component entirely once determined it is not needed (e.g. will CTFM have a use for this component?)
 */

import React, { Component } from 'react'
import { connect } from 'react-redux'
import ResponsiveAdStrategy from '@chegg-wt/core/components/ResponsiveAdStrategy'
import { FixedAdvert, Advert } from '@chegg-wt/core/components/Advert'
import { hideB1PlaceholderSelector } from '@chegg-wt/core/state/featureFlags/selectors'
import { AppState } from '@chegg-wt/core/state'
import { Background, Contents } from '@chegg-wt/core/components/Layouts/styled'
import { hasSideViewForRoute } from '@chegg-wt/core/utils/adframe'
import { reloadAds } from '@chegg-wt/core/utils/ads'
import { setAppScroller } from '@chegg-wt/core/utils/scroll'
import { AppRouteName } from '@chegg-wt/core/types/core'
import {
  BottomTray,
  CheckboxMenu,
  MainFrame,
  MainView,
  PseudoFixedPlacements,
  SideFrame,
  SideView,
  Viewports,
  LiftedContainer,
  R2R3Wrapper,
  HideB1Wrapper,
} from './styled'
import * as TestIds from './testIds'

// AdFrame wrapper for layout content that appears above the video player in lvp layouts
export const TopContentWrapper: React.FC = ({ children }) => (
  <Background>
    <Contents>{children}</Contents>
  </Background>
)

interface AdFrameProps {
  children: React.ReactNode
  hideB1Placeholder: boolean
  routeName: AppRouteName
  isPro: boolean
  showSvp: boolean
}

const LiftedPlacements: React.FC<{
  shouldBeDisplayed: boolean
}> = ({ shouldBeDisplayed }) => (
  <LiftedContainer shouldBeDisplayed={shouldBeDisplayed}>
    <Advert placement="R1" />
    <R2R3Wrapper>
      <Advert placement="R2" />
      <Advert placement="R3" />
    </R2R3Wrapper>
  </LiftedContainer>
)
export class AdFrame extends Component<AdFrameProps> {
  mainFrameRef = React.createRef<HTMLDivElement>()

  componentDidMount() {
    this.updateScroller()
  }

  componentDidUpdate() {
    this.updateScroller()
  }

  updateScroller() {
    setAppScroller(this.mainFrameRef.current)
  }

  render() {
    const { children, hideB1Placeholder, routeName, isPro, showSvp } = this.props
    let B1Advert = hideB1Placeholder ? Advert : FixedAdvert // adframe

    if (showSvp) {
      B1Advert = FixedAdvert // svp
    }

    const hideSideView = !hasSideViewForRoute(routeName) || isPro

    return (
      <>
        <ResponsiveAdStrategy renderAds={reloadAds} />
        <Viewports removeStyles={hideSideView}>
          <MainView>
            <MainFrame ref={this.mainFrameRef} id={TestIds.MAIN_FRAME_ID}>
              {children}
            </MainFrame>
            <BottomTray showSvp={showSvp}>
              <HideB1Wrapper showSvp={showSvp}>
                <B1Advert placement="B1" />
              </HideB1Wrapper>
              <CheckboxMenu id="checkbox-menu" />
            </BottomTray>
          </MainView>
          {!hideSideView && (
            <SideView data-test={TestIds.SIDEVIEW_TEST_ID}>
              <PseudoFixedPlacements>
                <Advert placement="VID" />
              </PseudoFixedPlacements>
              <SideFrame>
                <LiftedPlacements shouldBeDisplayed={!hideSideView} />
              </SideFrame>
            </SideView>
          )}
        </Viewports>
      </>
    )
  }
}

const mapStateToProps = (state: AppState) => ({
  hideB1Placeholder: hideB1PlaceholderSelector(state),
})

export default connect(mapStateToProps)(AdFrame)
